module.exports = __webpack_public_path__ + "static/close-a6276f4911f96ee058ee54eec268e615.svg";